var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Autocompleter',{attrs:{"solo":"","label":"Signal","readonly":_vm.readonly},model:{value:(_vm.localSettings.signal),callback:function ($$v) {_vm.$set(_vm.localSettings, "signal", $$v)},expression:"localSettings.signal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }